
const initialState = {
    // initialValues
}

export const InitReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INIT_QRY_FUNCTION': {
            return { ...action.payload }
        }
        default:
        return state
    }
}